import { MainContactCoverage } from 'src/domain/analytics';

/** Chart order runs from most to least engaged; inactive sits between active and invited. */
export const COVERAGE_STATUSES: readonly {
    key: Exclude<keyof MainContactCoverage, 'unknownLoginHistory'>;
    color: string;
}[] = [
    { key: 'active', color: '#779645' },
    { key: 'previouslyLoggedIn', color: '#D2D98A' },
    { key: 'neverLoggedIn', color: '#FFE9AA' },
    { key: 'noLinkedContact', color: '#CB2506' },
];
